module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_MT-4153e17a1190fb879001cda2ed751a14.svg";